"use client";

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQSectionProps {
  title: string;
  description: string;
  items: FAQItem[];
  className?: string;
}

export function FAQSection({ title, description, items, className }: FAQSectionProps) {
  return (
    <div className={`py-16 bg-muted/30 ${className || ''}`}>
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4">
            {title}
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            {description}
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {items.map((item, index) => (
            <div key={index} className="bg-card rounded-xl p-6 border">
              <h3 className="text-lg font-semibold mb-3">
                {item.question}
              </h3>
              <p className="text-muted-foreground">
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

